const getAverageEventsPerAttendee = (allAttendees, uniqueAttendees) => {
  let averageEventsPerAttendee = (Math.round(allAttendees.length / uniqueAttendees.length * 10) / 10)
  if (isNaN(averageEventsPerAttendee)) {
    averageEventsPerAttendee = 0
  }
  return averageEventsPerAttendee
}

export default getAverageEventsPerAttendee
